var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.996,0C67.157,0,0.001,67.161,0.001,149.997C0.001,232.837,67.157,300,149.996,300s150.003-67.163,150.003-150.003 S232.835,0,149.996,0z M90.318,204.463c-5.727,0-10.361-4.635-10.361-10.364c0-5.724,4.635-10.359,10.361-10.359 c5.724,0,10.361,4.635,10.361,10.359C100.679,199.828,96.042,204.463,90.318,204.463z M90.318,160.361 c-5.727,0-10.361-4.635-10.361-10.367c0-5.724,4.635-10.359,10.361-10.359c5.724,0,10.361,4.635,10.361,10.359 C100.679,155.727,96.042,160.361,90.318,160.361z M90.318,116.26c-5.727,0-10.361-4.635-10.361-10.364 c0-5.724,4.635-10.359,10.361-10.359c5.724,0,10.361,4.635,10.361,10.359C100.679,111.625,96.042,116.26,90.318,116.26z  M220.044,203.814h-97.143c-5.729,0-10.374-4.645-10.374-10.374s4.645-10.374,10.374-10.374h97.143 c5.729,0,10.374,4.645,10.374,10.374S225.773,203.814,220.044,203.814z M220.044,160.048h-97.143 c-5.729,0-10.374-4.645-10.374-10.374s4.645-10.374,10.374-10.374h97.143c5.729,0,10.374,4.645,10.374,10.374 C230.418,155.402,225.773,160.048,220.044,160.048z M220.044,116.281h-97.143c-5.729,0-10.374-4.645-10.374-10.374 s4.645-10.374,10.374-10.374h97.143c5.729,0,10.374,4.645,10.374,10.374S225.773,116.281,220.044,116.281z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.23975f573b1371105a587a7df4c7054e.svg";
export { ForwardRef as ReactComponent };